import SectionedListViewController from "./sectioned-list-view-controller";
import { buildCaseListAppoitments } from "../utils/case-list-appoitments-builder";

class AdvanceMedicalAppointmentListViewController extends SectionedListViewController {
  buildScreenSection({ section_title, rows }) {
    const handleButtonClick = this.handleButtonClick.bind(this);

    const caseLists = buildCaseListAppoitments(
      rows,
      this.components,
      this.appData,
      handleButtonClick
    );
    return [
      { type: "text", params: "TDFieldOptionBold", title: section_title },
      ...caseLists
    ];
  }
}

export default AdvanceMedicalAppointmentListViewController;
